import $ from 'jquery';

export default function orderForm() {
    if($('.avu-order-form').length > 0) {
        if($('.wpcf7-form').length > 0) {
            $('.avu-contact-form-inner-container p')
                .each(function () {
                $(this).wrapInner('<div class="xx container ps-0 pe-0"><div class="row"></div></div>');
            });
            $('.row label').not('.label-full-width').not('.form-no-margin').each(function () {
                $(this).wrap('<div class="1 col-12 col-lg-6 mb-3"></div>');
            });
            $('.row label.label-full-width').not('.form-no-margin').each(function () {
                $(this).wrap('<div class="3 col-12 mb-3"></div>');
            });
            $('.row label.form-no-margin').each(function () {
                $(this).wrap('<div class="2 col-12"></div>');
            });
        }
    }

}